module.exports = __webpack_public_path__ + "static/media/preview.808a6548.jpg";